import { render, staticRenderFns } from "./public-admin.vue?vue&type=template&id=963663ac&"
import script from "./public-admin.vue?vue&type=script&lang=js&"
export * from "./public-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports